import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface MosaicGalleryRowNumberData {
  rowNumber: number;
  color: string;
}

@Component({
    selector: 'ts-mosaic-row-number',
    templateUrl: './mosaic-row-number.component.html',
    styleUrls: ['./mosaic-row-number.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MosaicRowNumberComponent {
  @Input() data: MosaicGalleryRowNumberData;
}
